import React, {useState, useEffect, useContext} from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import {customFilterOption} from '../../../utils/utils'
import {FormControl, Grid, InputLabel} from '@material-ui/core'
import {MyAccountContext} from '../../containers/Layout'

const SelectDropDown = props => {
    const {clientObject, setClientObject} = useContext(MyAccountContext)
    const [optionList, setOptionList] = useState([])
    const [loading, setloading] = useState(true)

    const formatSelectedOption = (selectedOptions, endpoint) => {
        let returnValue = ''
        if (!selectedOptions) return returnValue
        if (Object.keys(selectedOptions).length === 0) return returnValue
        switch (endpoint) {
            case 'accountcliententity':
                returnValue = {
                    value: selectedOptions.cliententityid
                        ? selectedOptions.cliententityid
                        : '',
                    label: selectedOptions.cliententityname
                        ? selectedOptions.cliententityname
                        : '',
                    obj: {...selectedOptions},
                }
                break
            default:
                break
        }
        return returnValue
    }

    const formatDropDownDataSource = (dataList, endPoint) => {
        let dropDownData = []
        switch (endPoint) {
            case 'accountcliententity':
                const cliententityList = dataList.length > 0 ? dataList : []
                cliententityList.forEach(element => {
                    dropDownData.push({
                        value: element.cliententityid,
                        label: element.cliententityname
                            ? (element.practiceid ? element.practiceid + ' - ' : '') +
                              element.cliententityname
                            : '',
                        obj: {...element},
                    })
                })
                break

            default:
                break
        }
        return dropDownData
    }

    useEffect(() => {
        if (props.data.length > 0) {
            setOptionList(formatDropDownDataSource(props.data, props.endPoint))
            setloading(false)
        }
    }, [props.data])

    const handleChange = option => {
        const returnVal = formatSelectedOption(option.obj, props.endPoint)
        setClientObject({
            ...clientObject,
            practiceid: returnVal.obj.practiceid,
            cliententityid: returnVal.value,
            cliententityname: returnVal.label,
            entitytypeid: returnVal.obj.entitytypeid,
            entitytype: returnVal.obj.entitytype,
            parentcliententityid: returnVal.obj.parentcliententityid || 0,
            clientprogramid: 0,
            clientprogramname: '',
            programid: 0,
        })
    }

    const selectedOptVal = clientObject
        ? {
              value: clientObject.cliententityid,
              label: clientObject.cliententityname
                  ? (clientObject.practiceid ? clientObject.practiceid + ' - ' : '') +
                    clientObject.cliententityname
                  : '',
              obj: {
                  cliententityid: clientObject.cliententityid,
                  cliententityname: clientObject.cliententityname,
              },
          }
        : ''

    return (
        <Grid
            item
            xs={12}
            className={`react-select-grid input-field__main_container ${props.cssClass}`}
        >
            <FormControl fullWidth className="input-field__container">
                <InputLabel data-shrink={true} className="react-select-label">
                    <span className="react-select-label__text">{props.fieldName}</span>
                </InputLabel>

                <Select
                    className="basic-single"
                    classNamePrefix="select"
                    value={selectedOptVal}
                    isDisabled={props.isDisabled}
                    isLoading={loading}
                    isClearable={props.isClearable}
                    isSearchable={props.isSearchable}
                    options={optionList}
                    onChange={handleChange}
                    placeholder={props.placeholder}
                    filterOption={customFilterOption}
                    theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                    })}
                    closeMenuOnSelect={true}
                />
            </FormControl>
        </Grid>
    )
}

SelectDropDown.propTypes = {
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    placeholder: PropTypes.string,
}

SelectDropDown.defaultProps = {
    isDisabled: false,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    data: [],
    placeholder: '',
    multiSelect: false,
    toShow: true,
}

export default SelectDropDown
